import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';

@Component({
	selector: 'app-checkboxes',
	templateUrl: './checkboxes.component.html',
	styleUrls: ['./checkboxes.component.css'],
})
export class CheckboxesComponent implements OnChanges {
	@Input() items: Array<any>;
	@Input() values;
	@Output() valuesChange = new EventEmitter();
	internalValues = {};

	constructor() {}

	ngOnChanges(): void {
		if (this.values === null || this.values === undefined) {
			return;
		}
		this.values.forEach((value) => {
			this.internalValues[value] = true;
		});
	}

	changed() {
		const returnValues = [];
		for (const property in this.internalValues) {
			if (!this.internalValues[property]) {
				continue;
			}
			returnValues.push(property);
		}
		this.valuesChange.emit(returnValues);
	}
}
